import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { useDirectionContext, Direction } from '../../../contexts/session/Locale.js';
import { LinearLoaderStyled } from './Linear.styled.js';

var _excluded = ["percentage", "color", "label", "live"];
var trackBackgroundColor = {
  primary: 'base.background',
  secondary: 'base.surface.floating.inverted'
};
var progressBackgroundColor = {
  primary: 'deprecated.primary.brand',
  secondary: 'base.surface'
};
var LinearLoader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var percentage = _ref.percentage,
    color = _ref.color,
    label = _ref.label,
    live = _ref.live,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  var clampedPercentage = percentage !== undefined ? Math.min(100, Math.max(0, percentage)) : undefined;
  var ariaProps = percentage !== undefined ? {
    role: 'progressbar',
    'aria-valuemin': clampedPercentage !== undefined ? 0 : undefined,
    'aria-valuenow': clampedPercentage,
    'aria-valuemax': clampedPercentage !== undefined ? 100 : undefined
  } : {
    role: 'alert',
    'aria-live': live
  };
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    backgroundColor: trackBackgroundColor[color],
    width: "100%",
    height: "4px",
    borderRadius: "base",
    overflow: "hidden"
  }, ariaProps, {
    "aria-label": label,
    ref: ref
  }), /*#__PURE__*/React.createElement(LinearLoaderStyled, {
    "aria-hidden": true,
    backgroundColor: progressBackgroundColor[color],
    borderRadius: "base",
    height: "100%",
    width: clampedPercentage !== undefined ? '100%' : '50%',
    $percentage: clampedPercentage,
    $isRtl: direction === Direction.RTL
  }));
});
LinearLoader.defaultProps = {
  live: 'assertive'
};
var LinearLoaderMemoized = /*#__PURE__*/React.memo(LinearLoader);
LinearLoaderMemoized.displayName = 'LinearLoader';

export { LinearLoaderMemoized as LinearLoader, LinearLoader as LinearLoaderWithoutMemoized };
//# sourceMappingURL=Linear.js.map
